import { useQuery } from 'src/core/api/hooks/useQuery';
import { type QueryState } from 'src/core/api/queryState';

import { type ExpenseCategory } from '../../../models/expenseCategory';

export const useExpenseCategoriesWithArchivedQuery = (): QueryState<
  ExpenseCategory[]
> => {
  return useQuery<ExpenseCategory[], ExpenseCategory[]>({
    key: 'expenseCategoriesWithArchived',
    request: {
      type: 'rest',
      target: 'companyAPI',
      endpoint: '/expense-categories?includeArchived=true',
    },
    reshapeData: (data) => data,
  });
};
